/* External */
import { combineReducers } from "redux";

/* Reducers */
import filters from "./filters/reducers";
import stationsWithSchedules from "./stationsWithSchedules/reducers";

export default combineReducers({
  filters,
  stationsWithSchedules
});
